export const setTemplate = (self, template_el) => {
  self.unsetTemplate();
  const template_layer_el = self._getTemplateLayerElThrowable();
  template_layer_el.appendChild(template_el);
};
